export const RightLoading = () => {
  return (
    <div className="w-full h-full flex justify-center items-center">
      <div className="w-12 h-12 border-4 border-blue-200 border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
};
